import React from 'react';
import PropTypes from 'prop-types';
import {Route, Redirect} from 'react-router-dom';
import SubRoutes from './SubRoutes';

const EnhancedRoute = (props: any) => {

    const {
        layout: Layout,
        redirect,
        routeConfig
    } = props;

    if (redirect) {
        return <Redirect to={{pathname: redirect}} />;
    }

    const {subRoutes} = routeConfig;

    const WrapperComponent = (props: any) => (
        Layout
            ? (
                <Layout {...props} routeConfig={routeConfig}>
                    <SubRoutes {...props} routes={subRoutes} routeConfig={routeConfig} />
                </Layout>
            )
            : <SubRoutes {...props} routes={subRoutes} routeConfig={routeConfig} />
    );

    // eslint-disable-next-line react/jsx-no-bind
    return <Route render={WrapperComponent} />;
};

EnhancedRoute.propTypes = {
    // eslint-disable-next-line
    path: PropTypes.string.isRequired,
    // eslint-disable-next-line
    exact: PropTypes.bool.isRequired,
    redirect: PropTypes.string.isRequired,
    layout: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
    routeConfig: PropTypes.shape({}).isRequired,
};

export default EnhancedRoute;
